import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { Accountsgroup } from '../../../interfaces/masters/accountsgroup';

@Injectable()
export class AccountsgroupApi {
    constructor(private api: HttpService) { }

    list(url: string, options?: any): Observable<any[]> 
    {
        const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
      }
    
      getById(url: string, options?: any): Observable<Accountsgroup> {
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directGet(url,header);
      }
    
      add(url:string, data: Accountsgroup):Observable<Accountsgroup>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directPost(url, data, header);
      }
    
      update(url:string, data: Accountsgroup):Observable<any>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directPut(url, data, header);
      }
    
      delete(url: string):Observable<any>{
        return this.api.directDelete(url);
      }
    
      getall(url: string, options?: any): Observable<any> {
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
      }

}
